<template>
  <div>
    <div class="class-date flex flex-center">
      <van-icon name="arrow-left" @click="prevArrow" />
      <span @click="selectDate">{{ date }}</span>
      <van-icon name="arrow" @click="nextArrow" />
    </div>
    <div class="attendance">
      <div class="student-attendance student-attendance-1">
        <div class="title flex flex-b flex-vc">
          <span>入校统计</span>
        </div>
        <div class="attendance-count-chart flex flex-b">
          <canvas id="chart" class="chart"></canvas>

          <div class="count flex flex-dc flex-b">
            <div class="count-item flex">
              <div class="yuan"></div>
              <div class="info">总人数</div>
              <div class="num">{{ data2.classNumber }}人</div>
            </div>

            <div class="count-item flex flex-vc">
              <div class="yuan qian"></div>
              <div class="info">已签到</div>
              <div class="num">{{ data2.normalNumber }}人</div>
            </div>
            <div class="count-item flex flex-vc">
              <div class="yuan que"></div>
              <div class="info">缺勤</div>
              <div class="num quec">{{ data2.absenceNumber }}人</div>
            </div>
            <hr style="background-color: #ececec; height: 1px; border: none" />
            <div class="count-item flex flex-vc">
              <div class="yuan qing"></div>
              <div class="info">请假</div>
              <div class="num">{{ data2.leaveNumber }}人</div>
            </div>
            <div class="count-item flex flex-vc">
              <div class="yuan que"></div>
              <div class="info">迟到</div>
              <div class="num">{{ data2.lateNumber }}人</div>
            </div>
          </div>
        </div>
      </div>
      <div class="student-attendance student-attendance-2">
        <div class="title flex flex-b flex-vc">
          <span>部门出勤</span>
          <div class="flex flex-vc">
            <span class="c37a" @click="linkPath(0)">查看详情 ></span>
          </div>
        </div>

        <div class="class-list">
          <!-- <div class="class-item flex flex-vc">
            <div class="name c999">部门</div>
            <div class="flex-1 progress"></div>
            <div class="percentage c999">已签到/应到</div>
          </div> -->
          <div class="class-item flex flex-vc">
            <div class="c999">部门</div>
            <div class="flex-1 progress"></div>
            <div class="c999">已签到/应到</div>
          </div>

          <!-- 部门列表 -->
          <div
            class="class-item"
            v-for="item in ratelist"
            :key="item.id"
            @click.stop="linkPath(item.id)"
          >
            <div class="class-item_div flex flex-vc">
              <div class="name">{{ item.deptName }}</div>
              <van-progress
                :percentage="item.attendanceRate"
                :show-pivot="false"
                stroke-width="8"
                class="flex-1 progress"
                color="linear-gradient(360deg, #76D1FF 0%, #0D93D5 100%)"
              />
              <div class="percentage">
                {{ item.normalNumber }}/{{ item.classNumber }}
              </div>
            </div>

            <div v-for="item2 in item.children" style="marginLeft: 1em" :key="item2.id" @click.stop="linkPath(item2.id)">
              <div class="class-item_div flex flex-vc" >
                <div class="name">{{ item2.deptName }}</div>
                <van-progress
                  :percentage="item2.attendanceRate"
                  :show-pivot="false"
                  stroke-width="8"
                  class="flex-1 progress"
                  color="linear-gradient(360deg, #76D1FF 0%, #0D93D5 100%)"
                />
                <div class="percentage">
                  {{ item2.normalNumber }}/{{ item2.classNumber }}
                </div>
              </div>
              <div v-for="item3 in item2.children" @click.stop="linkPath(item3.id)"  style="marginLeft: 1em" :key="item3.id">
                <div
                  class="class-item_div flex flex-vc"
                >
                  <div class="name">{{ item3.deptName }}</div>
                  <van-progress
                    :percentage="item3.attendanceRate"
                    :show-pivot="false"
                    stroke-width="8"
                    class="flex-1 progress"
                    color="linear-gradient(360deg, #76D1FF 0%, #0D93D5 100%)"
                  />
                  <div class="percentage">
                    {{ item3.normalNumber }}/{{ item3.classNumber }}
                  </div>
                </div>
                <div v-for="item4 in item3.children" @click.stop="linkPath(item4.id)"  style="marginLeft: 1em" :key="item4.id">
                <div
                  class="class-item_div flex flex-vc"
                >
                  <div class="name">{{ item4.deptName }}</div>
                  <van-progress
                    :percentage="item4.attendanceRate"
                    :show-pivot="false"
                    stroke-width="8"
                    class="flex-1 progress"
                    color="linear-gradient(360deg, #76D1FF 0%, #0D93D5 100%)"
                  />
                  <div class="percentage">
                    {{ item4.normalNumber }}/{{ item4.classNumber }}
                  </div>
                </div>
                
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="student-attendance student-attendance-3" v-if="false">
        <div class="title flex flex-b flex-vc">
          <span>{{ data.monthTime }}月出勤汇总</span>
        </div>
        <div class="list flex">
          <div class="list-item">
            <span>全勤</span>
            <span>{{ data.overNumber }}人</span>
          </div>
          <div class="list-item">
            <span>缺勤</span>
            <span style="color: #ff738f">{{ data.absenceNumber }}人</span>
          </div>
          <div class="list-item">
            <span>请假</span>
            <span>{{ data2.leaveNumber }}人</span>
          </div>
          <div class="list-item">
            <span>迟到</span>
            <span>{{ data.lateNumber }}人</span>
          </div>
          <div class="list-item">
            <span>早退</span>
            <span>{{ data.earlyNumber }}人</span>
          </div>
        </div>
      </div>
    </div>
    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
  </div>
</template>

<script>
import F2 from "@antv/f2/lib/index-all";
import SelectTime from "@/components/subScribePopup/selectTime";
import moment from "moment";
export default {
  data() {
    return {
      data: {
        // attendance: 1,
        // normal: 20,
        // normal: 30,
        // leaveNumber: 30,
      },
      data2: {},
      chart: null,
      date: moment().format("YYYY-MM-DD"),
      startMinTime: new Date(moment().format("YYYY-MM-DD")),
      minDate: new Date(2020, 1, 1),
      ratelist: [],
      guide: null,
    };
  },
  mounted() {
    this.getChatData();
    this.getRate();
    this.getDeptSigninHistory();
  },
  methods: {
    async getChatData() {
      const { data, code } = await this.$https.getTeacherDataByschoolId({
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      });
      if (code !== 200) {
        return;
      }
      const d = data[0];
      let dat = [
        {
          name: "已签到",
          percent: d.normalNumber,
          a: "1",
        },
        {
          name: "缺勤",
          percent: d.absenceNumber,
          a: "1",
        },
      ];
      const rate = ((d.normalNumber / d.classNumber) * 100).toFixed(2);
      this.data2 = d;
      this.$nextTick(() => {
        if (this.guide) {
          this.guide.remove();
        }
        this.renderBase(dat, rate);
      });
    },
    prevArrow() {
      this.date = moment(this.date).subtract(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).subtract(1, "days").format("YYYY-MM-DD")
      );
    },
    nextArrow() {
      this.date = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).add(1, "days").format("YYYY-MM-DD")
      );
    },
    selectDate() {
      this.$refs.starttime.showTimePopup = true;
    },
    handleTimeStartConfirm(v) {
      this.date = v;
      this.getChatData();
      this.getRate();
    },
    renderBase(data, rate) {
      this.chart = new F2.Chart({
        id: "chart",
        pixelRatio: window.devicePixelRatio,
        padding: [5, 5],
      });
      this.chart.source(data);
      this.chart.tooltip(false);
      this.chart.legend(false);
      this.chart.coord("polar", {
        transposed: true,
        innerRadius: 0.7,
        radius: 1,
      });
      this.chart.axis(false);
      this.chart
        .interval()
        .position("a*percent")
        .color("name", ["#76D1FF", "#FF738F"])
        .adjust("stack");
      this.guide = this.chart.guide().html({
        position: ["50%", "53%"],
        html: `<div style="width: 250px;height: 40px;text-align: center;">
              <div style="font-size: 1.0625rem;color:#A9AAB0;" id="dddddd">${rate}%</div>
              <div style="font-size: 0.8125rem;color:#A9AAB0;" id="aaaaaa">出勤率</div>
            </div>`,
      });
      this.chart.render();
    },
    linkPath(id) {
      this.$router.push(`./schoolTeacherClass?id=${id}&date=${this.date}`);
    },
    async getRate() {
      const { data, code } =
        await this.$https.getDeptStaticsDataByschoolIdAndDate({
          schoolId: this.$store.state.schoolId,
          toDay: this.date,
        });
      if (code !== 200) {
        return false;
      }
      this.ratelist = data;
    },
    async getDeptSigninHistory() {
      const { data, code } = await this.$https.getDeptSigninHistory({
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      });
      if (code !== 200) {
        return false;
      }
      this.data = data;
    },
  },
  watch: {
    date() {
      this.getChatData();
      this.getRate();
      this.getDeptSigninHistory();
    },
  },
  components: {
    SelectTime,
  },
};
</script>

<style lang="scss" scoped>
.class-date {
  padding: 15px 0;
  span {
    margin: 0 20px;
    font-size: 15px;
    color: #1a1a1a;
  }
}
.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}
.attendance {
  padding: 0 15px 30px;
}
.c666 {
  color: #666666;
  font-size: 13px;
}
.c37a {
  color: #37a5da;
}
.c999 {
  color: rgb(198, 198, 198);
  font-size: 12px;
}
.student-attendance {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}
.student-attendance-1 {
  .attendance-count-chart {
    padding: 27px;
    .chart {
      width: 135px;
      height: 135px;
      /* border: 1px solid #37a5da; */
    }
    .count {
      &-item {
        font-size: 13px;
        .yuan {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          &.qian {
            background: #76d1ff;
          }
          &.qing {
            background: #f0c81e;
          }
          &.que {
            background: #ff738f;
          }
        }
        .quec {
          color: #ff738f;
        }
        .info {
          display: inline-block;
          min-width: 50px;
          color: #666666;
          margin: 0 16px 0 6px;
        }
      }
    }
  }
}
.student-attendance-2 {
  .class-list {
    .class-item {
      padding: 8px 15px 0 23px;
      font-size: 13px;
      color: #666666;
      .class-item_div {
        margin-bottom: 8px;
       
      }
      .name {
        /* width: 40px; */
        max-width: 100px;
        min-width: 100px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .progress {
        margin: 0 15px;
      }
      .percentage {
        /* color: #48b6ed; */
        font-size: 12px;
        // width: 20px;
      }
    }
  }
}

.student-attendance-3 {
  .list {
    padding: 5px 10px;
    font-size: 14px;
    color: #666;
    flex-wrap: wrap;
    .list-item {
      /* flex: 1; */
      width: 33%;
      padding: 5px;
      > span:last-child {
        margin-left: 10px;
      }
    }
  }
}
</style>
